import React from "react";
import { useTranslation } from "react-i18next";
import CardHeader from "../ui/CardHeader";
import Metric from "../ui/Metric";
import { formatInt } from "../../utils/formatters";

/**
 * AppointmentsCard — booked vs cancelled appointment counts plus a
 * cancellation-rate progress bar.
 *
 * Props:
 *   appointments: { booked, cancelled, cancellation_rate }
 *     cancellation_rate is a fraction in [0, 1].
 */
const AppointmentsCard = ({ appointments }) => {
  const { t } = useTranslation();
  const cancelPct = Math.round((appointments.cancellation_rate ?? 0) * 100);
  return (
    <div className="flat-card rounded-xl p-6 sm:p-8">
      <CardHeader
        icon="event_available"
        title={t("analytics.appointmentsCard.title")}
        subtitle={t("analytics.appointmentsCard.subtitle")}
      />
      <div className="grid grid-cols-2 gap-4 mb-4">
        <Metric
          label={t("analytics.appointmentsCard.booked")}
          value={formatInt(appointments.booked)}
          tone="ok"
        />
        <Metric
          label={t("analytics.appointmentsCard.cancelled")}
          value={formatInt(appointments.cancelled)}
          tone={appointments.cancelled > 0 ? "warn" : "default"}
        />
      </div>
      <div className="space-y-1">
        <div className="flex items-baseline justify-between text-xs">
          <span className="text-on-surface-light-variant dark:text-on-surface-variant">
            {t("analytics.appointmentsCard.cancellationRate")}
          </span>
          <span className="font-mono text-on-surface-light dark:text-on-surface">
            {cancelPct}%
          </span>
        </div>
        <div className="h-2 rounded-full bg-surface-light-low dark:bg-surface-container-low overflow-hidden">
          <div
            className="h-full bg-red-500/60 dark:bg-red-400/60"
            style={{ width: `${cancelPct}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default AppointmentsCard;
